import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { IconButtonSeeker } from 'ui-seeker/core'
import './drawerCloseButton.css'

// "X" close button for drawers whose native rsuite header is hidden (price detail drawers): placed in the
// custom header, it fits inside the title line height without making the header taller.
export default function AppDrawerCloseButton({ onClick }) {
    const { t } = useTranslation('common')

    return <IconButtonSeeker
        className="app-drawer-close-btn"
        icon="times"
        iconType="fontAwesome"
        size="small"
        title={t('common:actions.close')}
        onClick={onClick}
    />
}
